// import React, { useState, useRef, useEffect } from "react";
// import { ArrowDownTrayIcon, XMarkIcon } from "@heroicons/react/24/outline";

// const RenderAttachment = ({ attachment, attachmentType }) => {
//   console.log("Atcj", attachment)
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const modalRef = useRef(null);

//   const handlePreview = () => {
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//   };

//   const handleClickOutside = (event) => {
//     if (modalRef.current && !modalRef.current.contains(event.target)) {
//       closeModal();
//     }
//   };

//   useEffect(() => {
//     if (isModalOpen) {
//       document.addEventListener("mousedown", handleClickOutside);
//       return () =>
//         document.removeEventListener("mousedown", handleClickOutside);
//     }
//   }, [isModalOpen]);

//   const renderAttachment = (attachment, attachmentType) => {
//     if (attachmentType.includes("image")) {
//       return (
//         <img
//           onClick={handlePreview}
//           src={attachment}
//           alt="attachment"
//           className="w-40 rounded-lg cursor-pointer"
//         />
//       );
//     } else if (attachmentType.includes("video")) {
//       return (
//         <video src={attachment} controls className="w-40 max-w-xs rounded-lg" />
//       );
//     } else if (attachmentType.includes("audio")) {
//       return (
//         <audio src={attachment} controls className="w-48 rounded-lg text-sm" />
//       );
//     } else if (attachmentType.includes("pdf")) {
//       return (
//         <div className="flex items-center w-44 space-x-2 p-0 border rounded-lg bg-gray-100 cursor-pointer hover:bg-gray-200">
//           <a href={attachment} download className="flex items-center">
//             <ArrowDownTrayIcon className="w-8 h-8 p-1 border border-red-600 bg-red-600 text-white rounded-s-lg" />
//           </a>
//           <div className="pl-6" onClick={handlePreview}>
//             <p className="text-xs font-medium">PDF Document</p>
//             <p className="text-xs text-gray-500">Click to view</p>
//           </div>
//         </div>
//       );
//     } else {
//       return (
//         <div className="flex items-center w-44 space-x-2 p-0 border rounded-lg bg-gray-100 cursor-pointer hover:bg-gray-200">
//           <a href={attachment} download className="flex items-center">
//             <ArrowDownTrayIcon className="w-8 h-8 p-1 border border-red-600 bg-red-600 text-white rounded-s-lg" />
//           </a>
//           <div className="pl-6" onClick={handlePreview}>
//             <p className="text-xs font-medium">Document</p>
//             <p className="text-xs text-gray-500">Click to view</p>
//           </div>
//         </div>
//       );
//     }
//   };

//   return (
//     <div>
//       {renderAttachment(attachment, attachmentType)}

//       {isModalOpen && (
//         <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
//           <div
//             ref={modalRef}
//             className="relative bg-white bg-opacity-60 rounded-lg shadow-lg p-1 max-w-3xl w-full"
//           >
//             <button
//               onClick={closeModal}
//               className="absolute top-2 right-2 hover:text-gray-900"
//             >
//               <XMarkIcon className="text-blue-600 h-4 w-4" />
//             </button>
//             {attachmentType.includes("image") ? (
//               <img
//                 src={attachment}
//                 alt="attachment"
//                 className="w-full h-auto max-h-[90vh] rounded-lg"
//               />
//             ) : attachmentType.includes("pdf") ? (
//               <iframe
//                 src={attachment}
//                 className="w-full h-96 rounded-lg"
//                 title="Document Preview"
//               />
//             ) : attachmentType.includes("msword") ||
//               attachmentType.includes(
//                 "vnd.openxmlformats-officedocument.wordprocessingml.document"
//               ) ||
//               attachmentType.includes("vnd.ms-powerpoint") ||
//               attachmentType.includes(
//                 "vnd.openxmlformats-officedocument.presentationml.presentation"
//               ) ? (
//               <iframe
//                 src={`https://docs.google.com/gview?url=${attachment}&embedded=true`}
//                 className="w-full h-96 rounded-lg"
//                 title="Document Preview"
//               />
//             ) : (
//               <div className="text-center p-4">
//                 <p className="text-lg">
//                   Preview not available for this file type.
//                 </p>
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default RenderAttachment;


// import { ArrowDownTrayIcon, XMarkIcon } from "@heroicons/react/24/outline";

// import React, { useState, useRef, useEffect } from "react";

// const RenderAttachment = ({ attachment, attachmentType, attachments }) => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const modalRef = useRef(null);

//   // Determine the final URL and type to display
//   // Logic: Check if 'attachments' array exists first, otherwise fallback to 'attachment' string
//   const displayUrl = attachments && attachments.length > 0 ? attachments[0].url : attachment;
//   const displayType = attachments && attachments.length > 0 ? attachments[0].type : attachmentType;

//   const handlePreview = () => {
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//   };

//   const handleClickOutside = (event) => {
//     if (modalRef.current && !modalRef.current.contains(event.target)) {
//       closeModal();
//     }
//   };

//   useEffect(() => {
//     if (isModalOpen) {
//       document.addEventListener("mousedown", handleClickOutside);
//       return () => document.removeEventListener("mousedown", handleClickOutside);
//     }
//   }, [isModalOpen]);

//   // If no URL is available, don't render anything
//   if (!displayUrl || !displayType) return null;

//   const renderContent = () => {
//     const isImage = displayType.includes("image");
//     const isVideo = displayType.includes("video");
//     const isAudio = displayType.includes("audio");
//     const isPdf = displayType.includes("pdf");

//     if (isImage) {
//       return (
//         <img
//           onClick={handlePreview}
//           src={displayUrl}
//           alt="attachment"
//           className="w-40 rounded-lg cursor-pointer hover:opacity-90 transition-opacity"
//         />
//       );
//     } else if (isVideo) {
//       return (
//         <video src={displayUrl} controls className="w-40 max-w-xs rounded-lg" />
//       );
//     } else if (isAudio) {
//       return (
//         <audio src={displayUrl} controls className="w-48 rounded-lg text-sm" />
//       );
//     } else if (isPdf) {
//       return (
//         <div className="flex items-center w-44 space-x-2 p-0 border rounded-lg bg-gray-100 cursor-pointer hover:bg-gray-200">
//           <a href={displayUrl} download target="_blank" rel="noopener noreferrer" className="flex items-center">
//             <ArrowDownTrayIcon className="w-8 h-8 p-1 border border-red-600 bg-red-600 text-white rounded-s-lg" />
//           </a>
//           <div className="pl-2" onClick={handlePreview}>
//             <p className="text-[10px] font-medium truncate w-24">PDF Document</p>
//             <p className="text-[10px] text-gray-500">Click to view</p>
//           </div>
//         </div>
//       );
//     } else {
//       // Default for CSV, Excel, etc.
//       return (
//         <div className="flex items-center w-44 space-x-2 p-0 border rounded-lg bg-gray-100 cursor-pointer hover:bg-gray-200">
//           <a href={displayUrl} download target="_blank" rel="noopener noreferrer" className="flex items-center">
//             <ArrowDownTrayIcon className="w-8 h-8 p-1 border border-blue-600 bg-blue-600 text-white rounded-s-lg" />
//           </a>
//           <div className="pl-2" onClick={handlePreview}>
//             <p className="text-[10px] font-medium truncate w-24">File Attachment</p>
//             <p className="text-[10px] text-gray-500">Click to download</p>
//           </div>
//         </div>
//       );
//     }
//   };

//   return (
//     <div>
//       {renderContent()}

//       {isModalOpen && (
//         <div className="fixed inset-0 flex items-center justify-center z-[9999] bg-black bg-opacity-75">
//           <div
//             ref={modalRef}
//             className="relative bg-white rounded-lg shadow-xl p-2 max-w-[90vw] max-h-[90vh]"
//           >
//             <button
//               onClick={closeModal}
//               className="absolute -top-10 right-0 text-white hover:text-gray-300 flex items-center gap-1"
//             >
//               <span className="text-sm">Close</span>
//               <XMarkIcon className="h-6 w-6" />
//             </button>
            
//             {displayType.includes("image") ? (
//               <img src={displayUrl} alt="Preview" className="max-w-full max-h-[80vh] object-contain" />
//             ) : displayType.includes("pdf") ? (
//               <iframe src={displayUrl} className="w-[80vw] h-[80vh] rounded" title="PDF Preview" />
//             ) : (
//               <div className="p-10 text-center">
//                 <p>Preview not available. Please download the file to view.</p>
//                 <a href={displayUrl} download className="text-blue-600 underline mt-2 block">Download File</a>
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default RenderAttachment;


import { ArrowDownTrayIcon, XMarkIcon } from "@heroicons/react/24/outline";

import React, { useState, useRef, useEffect } from "react";

const RenderAttachment = ({ attachment, attachmentType, attachments }) => {
  const [previewItem, setPreviewItem] = useState(null); // Track specific item for modal
  const modalRef = useRef(null);

  // Normalize data: ensure we always have an array with resolved type, url, and filename
  const normalizeItem = (item, defaultType) => {
    if (!item) return null;
    const url = typeof item === "string" ? item : (item.url || item.path || item.fileUrl || item.data?.url || "");
    if (!url) return null;

    let type = (typeof item === "object" ? (item.type || item.mimeType || item.data?.type) : "") || defaultType || "";
    let filename = (typeof item === "object" ? (item.filename || item.name) : "") || "";

    const cleanUrl = url.split("?")[0].toLowerCase();
    if (!type || type === "application/octet-stream") {
      if (/\.(png|jpe?g|webp|gif|svg|bmp|avif)$/i.test(cleanUrl)) {
        type = "image/" + (cleanUrl.match(/\.(png|jpe?g|webp|gif|svg|bmp|avif)$/i)?.[1] || "jpeg");
      } else if (/\.(mp4|webm|ogg|mov|m4v)$/i.test(cleanUrl)) {
        type = "video/" + (cleanUrl.match(/\.(mp4|webm|ogg|mov|m4v)$/i)?.[1] || "mp4");
      } else if (/\.(mp3|wav|ogg|aac|m4a|weba)$/i.test(cleanUrl)) {
        type = "audio/" + (cleanUrl.match(/\.(mp3|wav|ogg|aac|m4a|weba)$/i)?.[1] || "mp3");
      } else if (/\.pdf$/i.test(cleanUrl)) {
        type = "application/pdf";
      }
    }

    if (!filename) {
      try {
        const parts = url.split("?")[0].split("/");
        filename = decodeURIComponent(parts[parts.length - 1]) || "Attachment";
      } catch (e) {
        filename = "Attachment";
      }
    }

    return { url, type, filename };
  };

  const rawList = Array.isArray(attachments) && attachments.length > 0
    ? attachments
    : attachment
    ? (Array.isArray(attachment) ? attachment : [attachment])
    : [];

  const filesToRender = rawList
    .map((item) => normalizeItem(item, attachmentType))
    .filter(Boolean);

  const closeModal = () => setPreviewItem(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };
    if (previewItem) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [previewItem]);

  if (filesToRender.length === 0) return null;

  const renderSingleFile = (file, index) => {
    const type = file.type || "";
    const url = file.url;

    if (type.includes("image")) {
      return (
        <img
          key={index}
          onClick={() => setPreviewItem(file)}
          src={url}
          alt={file.filename || "attachment"}
          className="max-w-[200px] max-h-48 object-cover rounded-xl cursor-pointer hover:opacity-90 transition-opacity border border-slate-200/80 shadow-2xs"
        />
      );
    } else if (type.includes("video")) {
      return (
        <video
          key={index}
          src={url}
          controls
          className="max-w-[220px] max-h-52 rounded-xl border border-slate-200/80 shadow-2xs"
        />
      );
    } else if (type.includes("audio")) {
      return (
        <audio
          key={index}
          src={url}
          controls
          className="max-w-[220px] rounded-xl text-sm"
        />
      );
    } else {
      // PDF, CSV, Excel, etc.
      return (
        <div
          key={index}
          className="flex items-center w-48 space-x-2 p-1.5 border border-slate-200 rounded-xl bg-slate-50 cursor-pointer hover:bg-slate-100 transition-colors"
        >
          <a
            href={url}
            download={file.filename}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center shrink-0"
            onClick={(e) => e.stopPropagation()}
          >
            <ArrowDownTrayIcon
              className={`w-7 h-7 p-1.5 text-white rounded-lg ${
                type.includes("pdf") ? "bg-red-600" : "bg-blue-600"
              }`}
            />
          </a>
          <div
            className="pl-1 overflow-hidden flex-1"
            onClick={() => setPreviewItem(file)}
          >
            <p className="text-[11px] font-medium text-slate-800 truncate" title={file.filename}>
              {file.filename || "File"}
            </p>
          </div>
        </div>
      );
    };
  };

  return (
    <div className="flex flex-wrap gap-2">
      {/* Loop through all files */}
      {filesToRender.map((file, index) => renderSingleFile(file, index))}

      {/* Modal for Preview */}
      {previewItem && (
        <div className="fixed inset-0 flex items-center justify-center z-[99999] bg-black bg-opacity-80 p-4">
          <div
            ref={modalRef}
            className="relative bg-white rounded-lg shadow-xl p-2 max-w-[90vw] max-h-[90vh] overflow-hidden"
          >
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-gray-800 hover:text-black z-10 bg-white rounded-full p-1 shadow"
            >
              <XMarkIcon className="h-6 w-6" />
            </button>
            
            <div className="mt-4">
                {previewItem.type.includes("image") ? (
                <img src={previewItem.url} alt="Preview" className="max-w-full max-h-[80vh] object-contain" />
                ) : previewItem.type.includes("pdf") ? (
                <iframe src={previewItem.url} className="w-[80vw] h-[80vh] rounded" title="PDF Preview" />
                ) : (
                <div className="p-10 text-center">
                    <p className="font-bold text-lg mb-2">{previewItem.filename}</p>
                    <p className="text-gray-600 mb-4">Preview not available for this file type.</p>
                    <a href={previewItem.url} download className="bg-blue-600 text-white px-6 py-2 rounded-full inline-block">Download File</a>
                </div>
                )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RenderAttachment;